import React, { Component } from 'react';

import './RetrievalForms.css';

import { background_10, services3 } from '../../theme/images';
import Page from '@acri-tools/react-tools/components/Page/Page';
import Documents from '../../components/Documents/Documents';
import { DOCUMENT_CATEGORIES } from '../../utils/documents';
import { Helmet } from 'react-helmet';
import { get_page_title } from '../../utils/config';

interface Props{
}
interface State{
}

class RetrievalForms extends Component<Props,State>{
    render(){
        return (
        <Page 
            id="retrieval-forms"
            banner={{
                title: "retrieval forms",
                bannerImage: background_10,
                topBar: true
            }}
            footer
        >
            <Helmet>
                <title>{ get_page_title(`DAMPS - Retrieval Forms`) }</title>
                <meta 
                    name="description" 
                    content="DAMPS retrieval forms information"
                />
            </Helmet>
            <div className="page-content">
                <div className="centered-content padding">
                    {
                        DOCUMENT_CATEGORIES["RetrievalForms"]?.map((category:string, index:number)=>(
                            <Documents
                                default_toggled={index === 0}
                                category={category}
                            />
                        ))
                    }
                </div>
            </div>
        </Page>
        );
    }

};


export default RetrievalForms;
